import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-WEB_BGXT",
  "use": "rt-portal-WEB_BGXT-usage",
  "viewBox": "-1111 -61 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"-1111 -61 1024 1024\" id=\"rt-portal-WEB_BGXT\">\r\n<path d=\"M-183,99h-832c-17.7,0-32,14.3-32,32v640c0,17.7,14.3,32,32,32h832c17.7,0,32-14.3,32-32V131C-151,113.3-165.3,99-183,99z\r\n\t M-277.5,171.1L-599,421l-321.5-249.9H-277.5z M-223,209.8V731h-752V209.8l-27.6-21.5l0,0l27.5,21.4l341.6,265.6\r\n\tc20.2,15.7,48.5,15.7,68.7,0L-223,209.8l27.6-21.5h0.1L-223,209.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/WEB_BGXT.svg
// module id = 676
// module chunks = 99